import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import variableBindingMixin from './variableBindingMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { QInput } from 'quasar';

import { appSettings } from '@/Shared/appSettings.js';

import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-textarea',
    mixins: [BaseComponent, variableBindingMixin],
    components: {
        TranslationContainer,
        QInput,
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        placeholder() {
            if (this.element && this.element.schema)
                return this.element.schema.placeholder;
            else
                return undefined;
        },
    },
    methods: {
    },
    render() {
        const variableField = this.tryRenderVariableBindingField({
            class: 'caption q-pa-none q-ma-none c-SformTextarea c-variable-binding-select',
            labelSlot: true,
        });
        if (variableField)
            return variableField;

        let slots = {
            message: ({ message }) => <TranslationContainer context={this} value={message}></TranslationContainer>,
        };
        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;
        slots = this.mergeVariableAssistSlots(slots);

        let input =
            <QInput
                rows={this.element.formatData ? this.element.formatData.Rows || "4" : "4"}
                class="caption q-pa-none q-ma-none c-SformTextarea"
                type="textarea"
                outlined
                dense
                labelSlot={this.hasInputLabel}
                style={{ width: "100%" }}
                placeholder={this.Translate(this.placeholder)}
                modelValue={this.itemvalue}
                rules={this.rules} {...this.compilerErrorFieldProps}
                onUpdate:modelValue={(value) => this.sync(value)}
                onFocus={() => { this._vbFocused = true; this.onFocus(); }}
                onBlur={() => { this._vbFocused = false; this.onBlur(); }}
                hint={this.inputHint}
                hide-hint
                bottom-slots={this.showFieldBottomSlots}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</QInput>;

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);

        return this.wrapLiteralWithVariableAssist(input);
    }
});
